import axios from 'axios'
import store from '@/store'
import router from '@/router'

import { MessageBox, Message } from 'element-ui'
// import loginDialog from '../components/LoginDialog'
// import { userRefreshToken } from './main'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 50000
})

// 存储待重试的请求队列
let isRefreshing = false;  // 是否正在刷新token
let isShowingLogin = false;  // 是否正在显示登陆弹窗
let requestsQueue = [];  // 重试队列

service.interceptors.request.use(
  config => {
    let token = localStorage.getItem("37aiToken")
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    console.log(error);
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  async response => {
    const res = response.data

    if (res.code == 200) {
      return res
    } else {
      if (res.code == 4001 || res.code == 4000) {
        store.dispatch('USER_LOGOUT').then(() => {
          location.reload()
        })
      }
      // if (res.code == 4000) {
      //   // 未登录  因为在router做了拦截，如果token是空就打开登录弹窗，所以应该不会触发这里
      //   console.log(res.code);
      //   await openLogin()
      // } 
      // if ([4002, 4001].includes(res.code)) {
      //   // 4002-token过期   请求刷新token，并且把请求接口存起来
      //   // 4001-refresh过期  直接退出登录
      //   return handleAuthError(response.config, res.code)
      // } else {
      Message({
        message: res.msg,
        type: 'error',
      })
      // }
      return Promise.reject(response); // 阻止返回结果
    }

  },
  error => {
    // response.
    // message
    // console.log(error);
    Message({
      message: error.msg,
      dangerouslyUseHTMLString: true,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

async function getRefreshToken() {
  try {
    const res = await userRefreshToken()
    store.commit('setToken', res.data.token)
    return res.data.token
  } catch (error) {
    store.dispatch('USER_LOGOUT')
    throw error
  }

}

// 执行队列里的请求
async function retryQueuedRequests(newToken) {
  if (requestsQueue.length) {
    // 复制当前队列（避免执行过程中被修改）
    const queueToRetry = [...requestsQueue]
    // 立即清空队列（防止重复执行）
    requestsQueue = []
    // 传递新 Token 给每个请求
    queueToRetry.forEach(cb => cb(newToken))
  }
}

// 清空队列（路由跳转时调用）
export function clearRequestsQueue() {
  requestsQueue = []
}


async function handleAuthError(config, code) {
  // 如果是 4002 且未在刷新，尝试刷新 Token
  if (!isRefreshing && code == 4002) {
    isRefreshing = true;
    try {
      const refreshToken = await getRefreshToken()
      // 刷新成功，用新 Token 重试当前请求
      config.headers.Authorization = `Bearer ${refreshToken}`
      // 先重新发起原始请求（不进入队列）
      const response = await service(config)
      // 重试队列中的其他请求
      retryQueuedRequests(refreshToken)
      return response
    } catch (error) {
      // 如果刷新失败，降级到4001
      code = 4001;
    } finally {
      isRefreshing = false;
    }
  }
  // 在code是4001或者在4002但是刷新失败的时候，强制退出并加入队列
  if (code == 4001) {
    store.dispatch('USER_LOGOUT')
  }
  // 将当前请求加入队列
  return new Promise(resolve => {

    requestsQueue.push((latestToken) => {
      // 动态使用最新的 Token
      // let refreshToken = localStorage.getItem("aiJHToken");
      config.headers.Authorization = `Bearer ${latestToken}`
      resolve(service(config))
    })

    // 把这个写在里面的话，只有第一个请求会触发弹窗（isShowingLogin 初始为 false），写在外面可能会有多个请求同时进入
    if (code == 4001 && !isShowingLogin) {
      isShowingLogin = true;
      loginDialog.open().then(loginSuccess => {
        if (loginSuccess) {
          console.log('cg', requestsQueue);
          // 登录成功 ，关闭弹窗 + 重试队列
          const newToken = localStorage.getItem('aiJHToken')
          retryQueuedRequests(newToken)
          // 仅登陆成功时重置状态（取消登录时不重置）
          isShowingLogin = false
        } else {
          // 取消登录，保持isShowingLogin=true（不关闭弹窗），队列保留
          // requestsQueue = [];
        }
      }).finally(() => {

      })
    }
  })

}

export default service